import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { CitationHighlight } from "./citationHighlightsHelper";

const HIGHLIGHT_PADDING_PCT = 0.3;

interface Props {
  highlight: CitationHighlight;
  isSelected: boolean;
}

const CitationHighlightOverlay = ({ highlight, isSelected }: Props) => {
  const theme = useTheme();

  return (
    <Box
      data-citation-id={highlight.citationId}
      sx={{
        position: "absolute",
        left: `${highlight.leftPct - HIGHLIGHT_PADDING_PCT}%`,
        top: `${highlight.topPct - HIGHLIGHT_PADDING_PCT}%`,
        width: `${highlight.widthPct + 2 * HIGHLIGHT_PADDING_PCT}%`,
        height: `${highlight.heightPct + 2 * HIGHLIGHT_PADDING_PCT}%`,
        backgroundColor: isSelected
          ? alpha(theme.palette.primary.main, 0.18)
          : alpha(theme.palette.warning.light, 0.18),
        border: isSelected ? `2px solid ${theme.palette.primary.main}` : "none",
        borderRadius: 0.5,
        pointerEvents: "none",
        transition: "background-color 0.2s ease",
      }}
    />
  );
};

export default CitationHighlightOverlay;
